import { useObservableRef } from "./useObservableRef.hook";
import { useResizeQuery } from "./useResizeQuery";
export var useCreateResizeQueryWithRef = function () {
    var ref = useObservableRef();
    var query = useResizeQuery(ref);
    return { ref: ref, query: query };
};
